import { environment } from '../../../environments/environment';

export const ApiEndpoints = {
  authentication: {
    login: environment.apiUrl + '/authentication/login',
    logout: environment.apiUrl + '/client/Accounts/me/sign-out',
    refreshToken: environment.apiUrl + '/authentication/refresh-token',
  },

  configurations: {
    GetByName: environment.apiUrl + '/client/configurations',
    GetClientData: environment.apiUrl + '/client/Accounts/clients',
    timeZone: environment.apiUrl + '/core/google-map/timezone',
    timeZoneData: environment.apiUrl + '/core/timezone',
    serverTimeZone: environment.apiUrl + '/client/timezone/server-timezone',
  },

  dashboards: {
    GetDashboard: environment.apiUrl + '/client/dashboard',
    GetDashboardCharts: environment.mainapiUrl + '/Charts/GetDashboardCharts',
    GetDashboardStatistic:
      environment.mainapiUrl + '/Charts/GetDashboardStatistic',
  },
};
